import { Context } from "@nuxt/types";

import Api from "@/utils/api";

const DEFAULT_POST_LIMITS = 10;

export default class TrendingPostApi extends Api {
  constructor($axios: Context["$axios"]) {
    super("activityServiceV3", $axios);
  }

  async getTrendingPostsByProfileId({ profileId, limit = DEFAULT_POST_LIMITS }: TrendingPostParams) {
    return await this.request<TrendingPostResponse>({
      method: "GET",
      url: `/v3/activities/posts/profile/${profileId}`,
      params: {
        limit,
        includes: ["posts", "media_objects"],
        rank: "top_month",
      },
    });
  }
}
